import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import signIn from './routerList/signIn'
import warehouse from './routerList/warehouse'
import problem from './routerList/problem'
import porder from './routerList/porder'
import siteConfiguration from './routerList/siteConfiguration'
import order from './routerList/order'
import userManagement from './routerList/userManagement'
import userAuthorization from './routerList/userAuthorization'
import capital from './routerList/capital'
import JapaneseOffice from './routerList/JapaneseOffice'
import homePage from './routerList/homePage'
import auth from './routerList/auth'
import productManagement from './routerList/productManagement'
import spotCheck from './routerList/spotCheck'
import inventoryTransfer from './routerList/inventoryTransfer'


Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/home.vue'),
    children: [
      ...order,//订单
      ...signIn, //签收模块
      ...warehouse, //仓库模块
      ...problem, //问题处理
      ...siteConfiguration,//运维
      ...porder,//配送单
      ...userManagement,//客户管理
      ...capital,//资金
      ...JapaneseOffice,// 日本事务所
      ...homePage,//首页
      ...auth,//组织架构
      ...spotCheck,//抽查
      ...inventoryTransfer,//库存转移

    ]
  },
  // 商品管理
  ...productManagement,
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/Login.vue'),
  },
  /* 订单详情 */
  {
    path: '/orderDetail',
    name: 'orderDetail',
    component: () => import('../views/orderDetail/index.vue'),
  },
  // 商品跟进页面
  {
    path: '/productFollowUpPage',
    name: 'productFollowUpPage',
    component: () => import('@/views/home/order/productFollowUpPage/index'),
    meta: {

    }
  },
  /* 订单付款后详情详情 */
  {
    path: '/orderPaymentDetail',
    name: 'orderPaymentDetail',
    component: () => import('../views/orderDetail/orderPaymentDetail/index.vue'),
  },
  /* 辅料详情 */
  {
    path: '/materialDetail',
    name: 'materialDetail',
    component: () => import('@/views/home/warehouse/material/detail.vue'),
  },
  /* 物流详情 */
  {
    path: '/logisticsDetail',
    name: 'logisticsDetail',
    component: () => import('../views/logisticsDetail/index.vue'),
  },
  /* 核查详情 */
  {
    path: '/inspectDetail',
    name: 'inspectDetail',
    component: () => import('../views/inspectDetail/index.vue'),
  },
  /* 核查直接装箱 */
  {
    path: '/encasement',
    name: 'encasement',
    component: () => import('../views/inspectDetail/encasement/index.vue'),
  },
  /* 核查直接装箱详情 */
  {
    path: '/boxDetail',
    name: 'boxDetail',
    component: () => import('../views/inspectDetail/encasement/boxDetail/index.vue'),
  },
  /*问题产品详情 */
  {
    path: '/pre-saleProblem',
    name: 'pre-saleProblem',
    component: () => import('../views/problemDetail/index'),
  },
  // 通用、检品单详情
  {
    path: '/generalInspectionListDetails',
    name: 'generalInspectionListDetails',
    component: () => import( /* webpackChunkName: "inspection" */ '../views/inspectionOfGoods/generalInspectionListDetails/generalInspectionListDetails.vue'),
    meta: {
      activeMenu: 'menu3_follow_inspect_inspect', // 可用选中菜单
    }
  },
  /*售中问题产品详情 */
  {
    path: '/inSaleList',
    name: 'inSaleList',
    component: () => import('../views/problemDetail/inSaleList/index'),
  },

  // 复检单，提出
  {
    path: '/reinspectionListAndSubmission',
    name: 'reinspectionListAndSubmission',
    component: () => import( /* webpackChunkName: "inspection" */ '../views/inspectionOfGoods/reinspectionListAndSubmission/index.vue'),
    meta: {
      activeMenu: 'menu3_follow_inspect_inspect', // 可用选中菜单
    }
  },
  // 普检或精检单操作界面
  {
    path: '/operationInterfaceOfGeneralTestOrFineTestList',
    name: 'operationInterfaceOfGeneralTestOrFineTestList',
    component: () => import( /* webpackChunkName: "inspection" */ '../views/inspectionOfGoods/operationInterfaceOfGeneralTestOrFineTestList/operationInterfaceOfGeneralTestOrFineTestList.vue'),
    meta: {
      activeMenu: 'menu3_follow_inspect_inspect', // 可用选中菜单
    }
  },
  /*配送单详情 */
  {
    path: '/porderDetail',
    name: 'porderDetail',
    component: () => import('../views/porderDetail/index'),
  },
  /*配送单-品名编辑预览 */
  {
    path: '/orderMaterialPreview',
    name: 'orderMaterialPreview',
    component: () => import('../views/porderDetail/components/orderMaterialPreview'),
  },
  /*配送单-发票编辑 */
  {
    path: '/invoiceEdit',
    name: 'invoiceEdit',
    component: () => import('../views/porderDetail/invoiceEdit/index'),
  },
  /*配送单-装箱明细 */
  {
    path: '/packingDetails',
    name: 'packingDetails',
    component: () => import('../views/porderDetail/packingDetails/index'),
  },
  /*用户订单预览 */
  {
    path: '/orderPreview',
    name: 'orderPreview',
    component: () => import('../views/home/userOrderManagement/order/orderPreview'),
  },
  /*用户配送单预览 */
  {
    path: '/deliveryPreview',
    name: 'deliveryPreview',
    component: () => import('../views/home/userOrderManagement/order/deliveryPreview'),
  },

  /*用户订单管理 */
  {
    path: '/user',
    name: 'user',
    component: () => import('../views/home/userOrderManagement/index'),
    children: [
      ...userAuthorization
    ]
  },
  /*创建通知公告 */
  {
    path: '/announcement',
    name: 'announcement',
    component: () => import('../views/home/siteConfiguration/notice/announcement'),
  },
  /*整单售后 */
  {
    path: '/wholeOrderAfterSale',
    name: 'wholeOrderAfterSale',
    component: () => import('../views/after-saleIndemnity/wholeOrderAfterSale'),
  },
  /*商品售后 */
  {
    path: '/afterSaleOfGoods',
    name: 'afterSaleOfGoods',
    component: () => import('../views/after-saleIndemnity/afterSaleOfGoods'),
  },

  /*项目发布页面 */
  {
    path: '/releaseProject',
    name: 'releaseProject',
    component: () => import('../views/releaseProject'),
  },
  /* 快递面单打印 */
  {
    path: '/expressSinglePrint',
    name: 'expressSinglePrint',
    component: () => import('../views/porderDetail/components/expressSinglePrint'),
  },
  /* 问题产品上传 */
  {
    path: '/mobileUpload',
    name: 'mobileUpload',
    component: () => import('../views/problemDetail/mobileUpload'),
  },
  /* 调查问卷 */
  {
    path: '/questionnaire',
    name: 'questionnaire',
    component: () => import('../views/home/userOrderManagement/userManagement/questionnaire/index'),
  },
  /* PDF转TXT */
  {
    path: '/PDFturnTXT',
    name: 'PDFturnTXT',
    component: () => import('../views/tool/PDFturnTXT'),
  },
  /*  给配货打印  */
  {
    path: '/printForDistribution',
    name: 'printForDistribution',
    component: () => import('../views/printForDistribution/index'),
  },
  /*  给FBA打印  */
  {
    path: '/FBAprint',
    name: 'FBAprint',
    component: () => import('../views/porderDetail/FBAprint/index'),
  },
  /*  chatwork群发消息  */
  {
    path: '/massMessaging',
    name: 'massMessaging',
    component: () => import('../views/home/siteConfiguration/notice/ChatWork/massMessaging'),
  },
  /*  rakuChat群发消息  */
  {
    path: '/rakuMessaging',
    name: 'rakuMessaging',
    component: () => import('../views/home/siteConfiguration/notice/rakuChat/rakuMessaging'),
  },
  /* 邮件群发消息  */
  {
    path: '/emailMessaging',
    name: 'emailMessaging',
    component: () => import('../views/home/siteConfiguration/notice/email/emailMessaging'),
  },

  /*  服务单详情  */
  {
    path: '/serviceDetail',
    name: 'serviceDetail',
    component: () => import('../views/inspectionOfGoods/serviceDetail/index'),
  },
  /*   创建商品   */
  {
    path: '/createProduct',
    name: 'createProduct',
    component: () => import('../views/home/siteConfiguration/customizedProducts/components/createProduct'),
  },

  /*   微信登录   */
  {
    path: '/wxLogin',
    name: 'wxLogin',
    component: () => import('../views/wx/wxLogin.vue'),
  },
  /*   创建自动任务   */
  {
    path: '/autoTaskEditing',
    name: 'autoTaskEditing',
    component: () => import('../views/home/spotCheck/autoGenerateTasks/autoTaskEditing'),
  },
  /*   西班牙企业微信登录   */
  {
    path: '/spainWxLogin',
    name: 'spainWxLogin',
    component: () => import('../views/login/spainWxLogin.vue'),
  },
  /*   微信登录   */
  {
    path: '/brLogin',
    name: 'brLogin',
    component: () => import('../views/wx/brLogin/index.vue'),
  },
  /*   授权成功   */
  {
    path: '/authorizationSuccess',
    name: 'authorizationSuccess',
    component: () => import('../views/wx/brLogin/authorizationSuccess.vue'),
  },

  /*   唐吉可的报价   */
  {
    path: '/tangJiKeDeBaoJia',
    name: 'tangJiKeDeBaoJia',
    component: () => import('../views/orderDetail/tangJiKeDeBaoJia/incex.vue'),
  },
  // 标签制作
  {
    path: '/labelProduction',
    name: 'labelProduction',
    component: () => import('../views/labelProduction/index.vue'),
  },
  /*   库存转移-详情   */
  {
    path: '/transferOrderDetail',
    name: 'transferOrderDetail',
    component: () => import('../views/home/inventoryTransfer/transferOrderDetail/index.vue'),
  },
  /*   定制1643   */
  {
    path: '/deliveryDate',
    name: 'deliveryDate',
    component: () => import('../views/orderDetail/deliveryDate/index.vue'),
  },
  /*   商品信息任务配置   */
  {
    path: '/productInfoRecordDetail',
    name: 'productInfoRecordDetail',
    component: () => import('../views/home/spotCheck/productInfoRecordSettings/productInfoRecordDetail/index.vue'),
  },



]


const router = new VueRouter({
  routes
})



// 挂载路由的全局前置守卫
/**
 * to: 将要去访问的路径
 * from: 从哪个路径跳转而来
 * next 是一个函数
 * next() 放行   next('/login') 强制跳转
 */
router.beforeEach((to, from, next) => {

  if (location.host.indexOf('co.jp') !== -1) {
    location.href = 'https://manage.rakumart.com/#/' + to.fullPath
  }

  if (to.path === '/login' || to.path === '/mobileUpload' || to.path === '/brLogin' || to.path === '/authorizationSuccess' || to.path === '/enterpriseWxLogin' || to.path === '/spainWxLogin') return next();
  if (to.path === '/') return next('/homePage');
  // 从url中获取token
  let token = to.query.token
  if (token) {
    localStorage.setItem("japan_access_token", token);

    let res = JSON.parse(window.name);
    if (!res.userInfo) {
      return
    }
    document.cookie = `japan_access_token=${token} ${res.userInfo.id}`;
    localStorage.setItem(
      "japanUserRoleInfo",
      JSON.stringify(res.userInfo)
    );
    localStorage.setItem(
      "japanUserRoleStatus",
      res.userInfo.role[0].work_type
    );
    store.dispatch("userAuth");
    store.dispatch("getMenu");


  }
  // 获取token
  const tokenStr = localStorage.getItem('japan_access_token');
  if (!tokenStr) return next('/login');
  next();
});
// 路由配置了标题时展示业务标题，其他页面保持项目原浏览器标题。
router.afterEach((to) => {
  document.title = to.meta && to.meta.title ? to.meta.title : 'rakumart-admin'
})
// router.afterEach((to, form, next) => {
//     let menu = JSON.parse(localStorage.getItem('menu'))
//     console.log(to.name, menu);
//     let flag = false
//     for (let i = 0; i < menu.length; i++) {
//         console.log(menu[i].child_menus);
//         if (menu[i].child_menus) {
//             for (let j = 0; j < menu[i].child_menus.length; j++) {
//                 if (to.name == menu[i].child_menus[j].route) {
//                     console.log(123);
//                     flag = true
//                     break
//                 }
//             }
//         }
//     }
//     if (!flag) {
//         next(from.path)
//     }
// })
export default router
